import { Dashboard } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        Dashboard,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'dashboard',
    icon: 'fa-tachometer-alt',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/Dashboard/index.ts